import ParagraphReWriter from '../../../src/components/content-ai-tools/ParagraphReWriter';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={ParagraphReWriter} />;
};

export default PublicDiscoveryKeywordsWrapped;
